import { HTTP_CODE } from '../../utils/redirector-utils';

export const isNotFound = (data) => {
  if (data && !data.content) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND,
      description: 'Page not found'
    };
  }

  return null;
};